function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E5E7"
    },
    d: "M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B7BD"
    },
    d: "M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAD1D8"
    },
    points: "480,224 384,128 480,128 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B84E"
    },
    d: "M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M96.816,314.656c2.944-24.816,40.416-29.28,58.08-15.712c8.704,7.024-0.512,18.16-8.192,12.528 c-9.472-6.016-30.96-8.832-33.648,4.464c-3.456,20.992,52.192,8.976,51.312,42.992c-0.896,32.496-47.984,33.264-65.648,18.672 c-4.224-3.44-4.096-9.056-1.792-12.528c3.328-3.312,7.04-4.464,11.392-0.896c10.48,7.168,37.488,12.544,39.392-5.648 C146.064,339.616,92.848,351.008,96.816,314.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M209.12,378.256l-33.776-70.752c-4.992-10.112,10.112-18.416,15.728-7.808l11.392,25.712 l14.704,33.776l14.448-33.776l11.392-25.712c5.12-9.712,19.952-3.584,15.616,7.04L226,378.256 C223.056,386.32,213.984,388.224,209.12,378.256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.76,374.16c-9.088,7.536-20.224,10.752-31.472,10.752c-26.88,0-45.936-15.36-45.936-45.808 c0-25.84,20.096-45.92,47.072-45.92c10.112,0,21.232,3.456,29.168,11.264c7.792,7.664-3.456,19.056-11.12,12.288 c-4.736-4.624-11.392-8.064-18.048-8.064c-15.472,0-30.432,12.4-30.432,30.432c0,18.944,12.528,30.448,29.296,30.448 c7.792,0,14.448-2.304,19.184-5.76V348.08h-19.184c-11.392,0-10.24-15.632,0-15.632h25.584c4.736,0,9.072,3.6,9.072,7.568v27.248 C348.96,369.552,347.936,371.712,345.76,374.16z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CAD1D8"
    },
    d: "M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgIcon);
export default __webpack_public_path__ + "static/media/svg-icon.88961ce57a208b6f719fe9ca167b8c0f.svg";
export { ForwardRef as ReactComponent };